import React from 'react';

import styled from '@ihme/common/theme/styled';
import _ from '@ihme/common/locale';

import formatChartValue from '../../../../utility/formatting/formatChartValue';

const Article = styled.article(({ theme }) => ({
    backgroundColor: '#F5F7F8',
    padding: '35px 30px 15px 30px',
    borderRadius: theme.borderRadius.base
}));

const Section = styled.section(({ theme }) => ({
    paddingBottom: 30
}));

const Header = styled.h2(({ theme, isHighlighted }) => ({
    marginTop: 0,
    marginBottom: 10,
    color: isHighlighted ? '#EF3828' : '#0094C9'
}));

const Stats = styled.p(({ theme }) => ({
    fontWeight: 600,
    paddingBottom: 10
}));

type Props = {
    locationId: number;
    locationValue: number;
    lowestLocations: number[];
    highestLocations: number[];
    isLoading: boolean;
};

const View = (props: Props) => (
    // @todo: add loading indicator
    <Article>
        <Section>
            <Header isHighlighted={true}>{_('factsheets_scene_yll_highest_rates')}</Header>
            {props.highestLocations.map((locationId, index) => (
                <p style={{ margin: 0 }} key={locationId + ' ' + index}>
                    <span>&nbsp;&nbsp;{index + 1}.&nbsp;&nbsp;&nbsp;</span>
                    {_(`location_${locationId}`)}
                </p>
            ))}
        </Section>

        <Section>
            <Header>{_('factsheets_scene_yll_lowest_rates')}</Header>
            {props.lowestLocations.map((locationId, index) => (
                <p style={{ margin: 0 }} key={locationId + ' ' + index}>
                    <span>&nbsp;&nbsp;{index + 1}.&nbsp;&nbsp;&nbsp;</span>
                    {_(`location_${locationId}`)}
                </p>
            ))}
        </Section>

        <Stats>
            {_('factsheets_scene_yll_location_stat', {
                location: _(`location_${props.locationId}`),
                years: formatChartValue(props.locationValue),
            })}
        </Stats>

        <p>
            Rates per 100,000 are adjusted for differences in ages and population size across
            countries.
        </p>
    </Article>
);

export default View;
